import axios from "@/utils/request";
export const getPageByPageid = params => {
    return axios.request({
        url: "/m/page/api/getByPageConfig/" + params
    });
};
